import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { IAuthor } from '@publishing-engine/domain/models';
import { useState } from 'react';
import { pluralizeString } from 'src/utils/string';

const MAX_VISIBLE_NAMES = 2;

interface Props {
  authors: IAuthor[];
  submittingAuthor?: { firstName: string; lastName: string };
  maxWidth?: string;
  isViewModeActive?: boolean;
}

export const SubmissionAuthors: React.FC<Props> = ({
  authors,
  submittingAuthor,
  maxWidth,
  isViewModeActive = true
}) => {
  const [showAllTags, setShowAllTags] = useState<boolean>(false);
  const hiddenCount = authors.length - MAX_VISIBLE_NAMES;

  const authorList = authors.slice(
    0,
    showAllTags ? Number.MAX_SAFE_INTEGER : MAX_VISIBLE_NAMES
  );

  return (
    <Flex
      maxWidth={maxWidth || '450px'}
      minWidth={0}
      flexWrap="wrap"
      alignItems={'center'}
      marginTop={1}
    >
      <Flex gap={1} wrap="wrap" minWidth={0} maxWidth="100%">
        {submittingAuthor && submittingAuthor.firstName && (
          <Text textStyle="textContext" whiteSpace="normal" overflowWrap="anywhere">
            {submittingAuthor.firstName} {submittingAuthor.lastName}
            {authorList.length > 0 && ','}
          </Text>
        )}
        {authorList.map((author, index) => (
          <Text
            textStyle="textContext"
            key={author.id}
            whiteSpace="normal"
            overflowWrap="anywhere"
            minWidth={0}
          >
            {[author.firstName, author.middleName, author.lastName]
              .filter(Boolean)
              .join(' ')}
            {index < authorList.length - 1 && ','}
          </Text>
        ))}
      </Flex>
      {isViewModeActive && authors.length > MAX_VISIBLE_NAMES ? (
        <Flex>
          <ButtonText
            onClick={e => {
              e.stopPropagation();
              setShowAllTags(prevValue => !prevValue);
            }}
            color="actionSecondaryContent"
            fontWeight="semibold"
            marginLeft={1}
            flexShrink={0}
          >
            <Text textStyle="textContext">
              {showAllTags
                ? 'See Less'
                : `+${hiddenCount} ${pluralizeString('author', hiddenCount)}`}
            </Text>
          </ButtonText>
        </Flex>
      ) : (
        authors.length > MAX_VISIBLE_NAMES && (
          <>
            <Text textStyle="textContext">,</Text>
            <Text textStyle="textContext" marginLeft={1}>
              +{hiddenCount}
            </Text>
          </>
        )
      )}
    </Flex>
  );
};
